import { z } from 'zod';
import { PARTNER_OFFER_OPEN_MAX } from './networking';

export const PartnerOfferStatus = z.enum(['OPEN', 'CLOSED']);
export type PartnerOfferStatus = z.infer<typeof PartnerOfferStatus>;

export const PartnerOfferDto = z.object({
  id: z.uuid(),
  userId: z.uuid(),
  cityId: z.uuid(),
  lookingForText: z.string(),
  offeringText: z.string().nullable(),
  status: PartnerOfferStatus,
  createdAt: z.iso.datetime(),
});
export type PartnerOfferDto = z.infer<typeof PartnerOfferDto>;

export { PARTNER_OFFER_OPEN_MAX };
